import { GC_FRONT_END_V1 } from "./perfis/exportEnvs";

export type RedirectToV1Options = {
  unidadeIdEditar?: number;
};

const IntegracaoV1 = () => {

  function redirectToV1(path: string, options?: RedirectToV1Options) {
    let token = localStorage.getItem("jhi-authenticationToken");
    if (token) {
      let payload: Record<string, unknown> = {
        jwt: token,
        mesCompetencia: localStorage.getItem("mesCompetencia"),
      };

      if (options?.unidadeIdEditar) {
        payload.unidadeIdEditarFromV2 = options.unidadeIdEditar;
      }

      let payloadB64 = encodeURIComponent(btoa(JSON.stringify(payload)));
      let url = `${GC_FRONT_END_V1}/#${path ? path : ""}?fromV2=${payloadB64}`;
      window.location.replace(url);
    }
  }

  function iniciarAcordosV1(idsContasReceber: number[]) {
    let token = localStorage.getItem("jhi-authenticationToken");
    if (token) {
      let payload = {
        jwt: token,
        idsContasReceberIniciarAcordosFromV2: idsContasReceber,
      };
      let payloadB64 = btoa(JSON.stringify(payload));
      let url = `${GC_FRONT_END_V1}/#/acordo/cadastrar?fromV2=${payloadB64}`;
      window.location.replace(url);
    }
  }

  const getDadosFromV1 = () => {
    var payloadFromV1B64 = window.location.search.slice(1).split("fromV1=")[1];
    if (payloadFromV1B64) {
      let payload = JSON.parse(atob(payloadFromV1B64));
      localStorage.setItem("jhi-authenticationToken", payload.jwt);
      if (payload.mesCompetencia) {
        localStorage.setItem("mesCompetencia", payload.mesCompetencia);
      }
      //LIMPAR URL
      let hashSemToken = window.location.hash.replace(payloadFromV1B64, "");
      hashSemToken = hashSemToken.replace("?fromV2=", "");
      const urlWithoutData = window.location.origin + window.location.pathname + hashSemToken;
      window.history.replaceState({}, document.title, urlWithoutData);
    }
  };
  return { redirectToV1, iniciarAcordosV1, getDadosFromV1 };
};
export default IntegracaoV1;
